import objToArr from "@helpers/objToArr";
import getActives from "@helpers/getActives";

function getModelOperational() {
  return [this.model.companyRpes, this.model.acls, this.model.companyRoles]
    .map(operational => getActives(objToArr(operational)))
    .map(this._getIdAndLicence);
}

export default getModelOperational;
